namespace $.$$ {

		export class $shm_hitalama_map_widget_float_entity_editor extends $.$shm_hitalama_map_widget_float_entity_editor {

		@ $mol_mem
		fields_text( next?: string ) {
			const dataset = this.widget().dataset()
			if( next === undefined ) return dataset.text()

			dataset.text( next )
			return next
		}

	}

}
